export const approachProcessChartReady = () => {
  // Four Menu buttons:
  // 1. process-chart-button-profit-growth-optimization
  // 2. process-chart-button-customer-experience
  // 3. process-chart-button-customer-due-diligence
  // 4. process-chart-button-value-creation

  // Init
  // Desktop
  document.querySelectorAll('.process-chart-menu').forEach(element => {
    element.addEventListener('click', (event) => {
      toggleProcessChartMenu(event),
      toggleProcessChartDiagram(event.target.getAttribute('process-chart-menu'));
    });
  }); 
  // Mobile - Dropdown Menu list
  if (document.querySelector('#our-approach-process-chart')) {
    document.querySelector('#our-approach-process-chart').addEventListener('change', () => {
      let selector = document.querySelector('#our-approach-process-chart').value;
      toggleProcessChartDiagram(selector);
    });
  }

};

const toggleProcessChartMenu = (event) => {
  const processChartMenuContainer = document.querySelector('.process-chart-menu-container');

  for (let i = 0; i < processChartMenuContainer.children.length; i++) {
    if (processChartMenuContainer.children[i].classList.contains('process-chart-menu-active')) {
      processChartMenuContainer.children[i].classList.remove('process-chart-menu-active');
    }
  };

  event.target.classList.add('process-chart-menu-active');
};

const toggleProcessChartDiagram = (event) => {
  switch (event) {
    case 'all':
      activateProcessChartDiagram('all');
      break;
    case 'profit-growth-optimization':
      activateProcessChartDiagram('profit-growth-optimization');
      break;
    case 'customer-experience':
      activateProcessChartDiagram('customer-experience');
      break;
    case 'customer-due-diligence':
      activateProcessChartDiagram('customer-due-diligence');
      break;
    case 'value-creation':
      activateProcessChartDiagram('value-creation');
      break;
    default:
      activateProcessChartDiagram('all');
      break;
  }
};

const activateProcessChartDiagram = (selectedMenu) => {
  const processChartDiagramContainer = document.querySelector('.process-chart-diagram-container');
  const processChartDiagramMobileContainer = document.querySelector('.process-chart-diagram-mobile-container');

  for (let i = 0; i < processChartDiagramContainer.children.length; i++) {
    if (processChartDiagramContainer.children[i].classList.contains('process-chart-diagram-active')) {
      processChartDiagramContainer.children[i].classList.remove('process-chart-diagram-active');
    }
    
    if (selectedMenu == 'all') {
      processChartDiagramContainer.children[i].classList.add('process-chart-diagram-active');
    } else if (processChartDiagramContainer.children[i].classList.contains(selectedMenu)) {
      processChartDiagramContainer.children[i].classList.add('process-chart-diagram-active');
    }
  }
  for (let i = 0; i < processChartDiagramMobileContainer.children.length; i++) {
    if (processChartDiagramMobileContainer.children[i].classList.contains('process-chart-diagram-active')) {
      processChartDiagramMobileContainer.children[i].classList.remove('process-chart-diagram-active');
    }
    
    if (selectedMenu == 'all') {
      processChartDiagramMobileContainer.children[i].classList.add('process-chart-diagram-active');
    } else if (processChartDiagramMobileContainer.children[i].classList.contains(selectedMenu)) {
      processChartDiagramMobileContainer.children[i].classList.add('process-chart-diagram-active');
    }
  }
};
